<script setup lang="ts">
import { computed } from 'vue'
import { isNotEmpty } from '@/utils/util'

const props = defineProps({
  msg: {
    type: String,
    default: ''
  },
  theme: {
    type: Boolean,
    default: false,
    required: false
  }
})

const msgComp = computed(() => props.msg)
</script>
<template>
  <!-- outer layout -->
  <div h-full w-full flex flex-col px-4 mt-6>
    <div w-full class="h-4/6" min-h-96 flex="~ col" items-center justify-center>
      <div flex-l-center>
        <div i-f7:doc-text-search text-4xl :class="props.theme ? 'bg-theme' : 'bg-m-pressed'"></div>
        <p
          v-if="isNotEmpty(msgComp)"
          mt-6
          leading-7
          max-w-80
          :class="props.theme ? 'text-theme-gray' : 'text-third'"
          text-center>
          {{ msgComp }}
        </p>
      </div>
      <slot></slot>
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
